import { Component, OnInit } from '@angular/core';
import { DefaultDisplayComponent } from "../default-display/default-display.component";
import { SummaryFlowViewComponent } from "../../summary-flow-view/summary-flow-view.component";

@Component({
    selector: 'checkbox-display',
    templateUrl: './checkbox-display.component.html',
    styleUrls: ['./checkbox-display.component.scss'],
    standalone: false
})
export class CheckboxDisplayComponent extends DefaultDisplayComponent implements OnInit {

    get displayType(): string {
        if (!this.question || !this.question.questionConfig) return "";
        if (this.question.questionConfig.summaryDisplay === undefined || this.question.questionConfig.summaryDisplay === undefined) {
            return "";
        }
        return this.question.questionConfig.summaryDisplay.type;
    }

    get otherChecked(): string {
        if (!this.question || !this.question.questionConfig) return "";
        if (this.question.questionConfig.summaryDisplay === undefined || this.question.questionConfig.summaryDisplay === undefined) {
            return "";
        }
        return this.question.questionConfig.summaryDisplay.otherChecked;        
    }

    get otherUnchecked(): string {
        if (!this.question || !this.question.questionConfig) return "";
        if (this.question.questionConfig.summaryDisplay === undefined || this.question.questionConfig.summaryDisplay === undefined) {
            return "";
        }
        return this.question.questionConfig.summaryDisplay.otherUnchecked;        
    }

    constructor() { super(); }

    ngOnInit() {
        super.ngOnInit();
    }

}
